import { Component, HostBinding } from '@angular/core';
import * as _ from 'lodash';
import { DashboardService } from './dashboard.service';
import { Store } from '@ngrx/store';
import { AppErrorComponent } from '../app.error.component';

@Component({
  selector: 'polaris-dashboard',
  template: `
    <div class="c-p-lg">
      <h3>{{ messageBasedOnState$ | async }}</h3>
    </div>
  `,
})
export class DashboardComponent extends AppErrorComponent {
  @HostBinding('class.ns-card-container')
  public 'true';

  public cards$ = this.dashboardService.cards$;

  constructor(
    private dashboardService: DashboardService,
    protected store: Store
  ) {
    super(store);
  }

  public positionChange(data: { positions: { id: string }[] }) {
    this.dashboardService.updatePositions(data.positions);
  }
}
